'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Parser = require('../Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _BaseInput = require('../BaseInput');

var _BaseInput2 = _interopRequireDefault(_BaseInput);

var _WebformElement = require('../WebformElement');

var _WebformElement2 = _interopRequireDefault(_WebformElement);

var _wrapper = require('./styled/wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _innerWrapper = require('./styled/inner-wrapper');

var _innerWrapper2 = _interopRequireDefault(_innerWrapper);

var _prefix = require('./styled/prefix');

var _prefix2 = _interopRequireDefault(_prefix);

var _suffix = require('./styled/suffix');

var _suffix2 = _interopRequireDefault(_suffix);

var _validationIcon = require('./styled/validation-icon');

var _validationIcon2 = _interopRequireDefault(_validationIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Input, _Component);

  function Input() {
    (0, _classCallCheck3.default)(this, Input);
    return (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).apply(this, arguments));
  }

  (0, _createClass3.default)(Input, [{
    key: 'getLabelDisplay',
    value: function getLabelDisplay() {
      return this.props.webformElement.getLabelDisplay();
    }
  }, {
    key: 'renderTextContent',
    value: function renderTextContent(selector) {
      var value = this.props.field['#field_' + selector];
      if (value) {
        var TextContent = selector === 'prefix' ? _prefix2.default : _suffix2.default;

        return _react2.default.createElement(
          TextContent,
          null,
          (0, _Parser2.default)(value)
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _wrapper2.default,
          { labelDisplay: this.getLabelDisplay(), className: 'hrw-input-wrap hrw-label-display-' + this.getLabelDisplay() },
          _react2.default.createElement(
            _innerWrapper2.default,
            null,
            this.renderTextContent('prefix'),
            _react2.default.createElement(_BaseInput2.default, (0, _extends3.default)({}, this.props, {
              field: this.props.field
            })),
            this.renderTextContent('suffix')
          )
        ),
        _react2.default.createElement(_validationIcon2.default, { success: this.props.webformElement.isSuccess(), className: 'hrw-validation-icon' })
      );
    }
  }]);
  return Input;
}(_react.Component), _class2.propTypes = {
  field: _propTypes2.default.shape({
    '#type': _propTypes2.default.string.isRequired,
    '#placeholder': _propTypes2.default.string,
    '#field_prefix': _propTypes2.default.string,
    '#field_suffix': _propTypes2.default.string,
    '#webform_key': _propTypes2.default.string.isRequired,
    '#required': _propTypes2.default.bool,
    '#mask': _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
    '#alwaysShowMask': _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
    '#min': _propTypes2.default.string,
    '#max': _propTypes2.default.string,
    '#step': _propTypes2.default.string,
    '#attributes': _propTypes2.default.oneOfType([_propTypes2.default.shape({
      autoComplete: _propTypes2.default.string
    }), _propTypes2.default.array])
  }).isRequired,
  webformElement: _propTypes2.default.instanceOf(_WebformElement2.default).isRequired
}, _temp)) || _class;

exports.default = Input;